import 'moment/locale/es'; // Asegura formato en español

import moment from 'moment';
import PropTypes from 'prop-types';
import {memo} from 'react';

import DatePreview from '@/components/DatePreview';

const DatePreviewWithRange = ({value, format, defaultValue, label, onlyRange}) => {
  moment.locale('es');
  
  let diffText = '';
  if (value) {
    const date = moment(value);
    if (date.isValid()) {
      const now = moment();
      const diffHours = date.diff(now, 'hours');
      let diffDays = date.diff(now, 'days');
      const diffMonths = date.diff(now, 'months');
      
      if (diffDays < 0)
        return '';
      
      if (!diffDays && !!diffHours)
        diffDays = 1;
      
      // Muestra de forma más natural el intervalo
      if (diffMonths >= 1) {
        const remainingDays = diffDays - diffMonths * 30;
        if (diffMonths >= 6) {
          diffText = 'más de 6 meses';
        } else if (remainingDays > 5) {
          diffText = `${diffMonths} ${diffMonths === 1 ? 'mes' : 'meses'} y ${remainingDays} días`;
        } else {
          diffText = `${diffMonths} ${diffMonths === 1 ? 'mes' : 'meses'}`;
        }
      } else {
        diffText = diffDays ? `${diffDays} ${diffDays === 1 ? 'día' : 'días'}` : '';
      }
    }
  }
  
  return (
    <div className="flex items-center gap-2">
      {!onlyRange && <DatePreview value={value} format={format} defaultValue={defaultValue} label={label}/>}
      {diffText && (
        <div className="italic font-semibold text-gray-600">
          ({diffText})
        </div>
      )}
    </div>
  );
};

DatePreviewWithRange.propTypes = {
  ...DatePreview.propTypes,
  onlyRange: PropTypes.bool,
};

export default memo(DatePreviewWithRange);
